<template>
  <div>
    <ca-heading text="Eventos" />
    <ca-row vertical-offset="2">
      <!-- TODO: verificar se ainda existe necessidade deste botão -->
      <!-- <ca-col size="2">
        <ca-button
          theme="primary"
          @click="onNew">
          Novo evento
        </ca-button>
      </ca-col> -->
      <ca-col size="4">
        <ca-field label="Busca">
          <ca-input-group>
            <ca-input
              v-model="search"
              placeholder="Código ou descrição"
              class="ca-u-no-margin" />
            <ca-button
              slot="button"
              theme="default"
              @click="handleSearch">
              Buscar
            </ca-button>
          </ca-input-group>
        </ca-field>
      </ca-col>
      <ca-col size="4">
        <ca-field label="Busca por Natureza">
          <ca-select
            v-model="nature"
            placeholder="Natureza"
            :on-change="handleSearch">
            <ca-option
              key="TODAS"
              value="TODAS">
              Todas
            </ca-option>
            <ca-option
              v-for="item in eventsNature"
              :key="item.name"
              :value="item.name">
              {{ item.description }}
            </ca-option>
          </ca-select>
        </ca-field>
      </ca-col>
    </ca-row>

    <ca-row>
      <ca-col>
        <ca-loader v-if="showLoading" />

        <ca-table v-else>
          <ca-tr slot="header">
            <ca-th size="4">Código</ca-th>
            <ca-th>Descrição</ca-th>
            <ca-th>Natureza</ca-th>
            <ca-th size="4">Observação</ca-th>
            <ca-th size="8">Compartilhado</ca-th>
            <ca-th size="11">
              Situação no eSocial
            </ca-th>
            <ca-th />
          </ca-tr>

          <ca-tr
            v-for="(event, index) in events.content"
            :key="index"
            @click="onView(event.id)">
            <ca-td>{{ event.code }}</ca-td>
            <ca-td>{{ event.description }}</ca-td>
            <ca-td>
              {{ event.eventNature.description }}
            </ca-td>
            <ca-td>{{ event.observation }}</ca-td>
            <ca-td>{{ event.shared ? 'Sim' : 'Não' }}</ca-td>
            <ca-td @click.native.stop="() => {}">
              <esocial-table-select
                v-model="event.esocialStatus.name"
                :object="event"
                @change="onEsocialChange" />
            </ca-td>
            <ca-td>
              <template v-if="event.defaultEvent">
                <ca-button size="small" @click.stop="onCopy(event.id)">
                  Copiar
                </ca-button>
              </template>
              <template v-else>
                <ca-button
                  class="ca-u-min-margin-right"
                  size="small"
                  @click.stop="onEdit(event.id)">
                  Editar
                </ca-button>
                <ca-button
                  size="small"
                  @click.stop="onDelete(index, event.id)">
                  Excluir
                </ca-button>
              </template>
            </ca-td>
          </ca-tr>
        </ca-table>
      </ca-col>
    </ca-row>

    <ca-row vertical-offset="2">
      <ca-col class="ca-u-text-center">
        <ca-pagination
          v-if="!showLoading && events.totalPages > 1"
          v-model="currentPage"
          :total-pages="events.totalPages"
          class="ca-u-flex ca-u-align-items--center ca-u-justify-content--center" />
      </ca-col>
    </ca-row>
  </div>
</template>

<script>
import EsocialTableSelect from 'accountant/esocial/components/esocial-table-select/EsocialTableSelect';
import { DELETE_MESSAGE, DELETE_TITLE } from './constants';
import {
  getEvents, deleteEvent, updateEsocialStatus,
} from './eventService';
import { getErrorMessageFromResponse } from '../../../packages/common';

export default {
  name: 'EventPage',
  components: {
    EsocialTableSelect,
  },
  data() {
    return {
      showLoading: false,
      currentPage: 0,
      search: '',
      events: {},
      nature: null,
      totalPages: 0,
    };
  },
  computed: {
    misc() {
      return this.$store.state.misc;
    },
    eventsNature() {
      return this.misc.eventsNature;
    },
  },
  watch: {
    currentPage() {
      this.setEvents();
    },
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.$store.dispatch('misc/getEventsNature');
      this.setEvents();
    },
    handleSearch() {
      this.currentPage = 0;
      this.setEvents();
    },
    async setEvents() {
      this.showLoading = true;
      try {
        const nature = this.nature === 'TODAS' ? '' : this.nature;
        this.events = await getEvents({
          search: this.search,
          page: this.currentPage,
          nature,
        });
      } catch (e) {
        this.$toaster.error('Aconteceu um erro, por favor tente novamente.');
      } finally {
        this.showLoading = false;
      }
    },
    onView(id) {
      this.$router.push({ name: 'EventView', params: { id } });
    },
    onNew() {
      this.$router.push({ name: 'EventNewForm' });
    },
    async onCopy(id) {
      try {
        this.$router.push({ name: 'EventEditForm', params: { id, fromCopy: true } });
      } catch (error) {
        this.$toaster.error(getErrorMessageFromResponse(error));
      }
    },
    onEdit(id) {
      this.$router.push({ name: 'EventEditForm', params: { id } });
    },
    async onEsocialChange(esocialStatus, event) {
      try {
        await updateEsocialStatus(event.id, esocialStatus);
        this.$toaster.success('Situação no eSocial alterada com sucesso!');
      } catch (error) {
        this.$toaster.error(getErrorMessageFromResponse(error));
      }
    },
    onDelete(index, id) {
      this.$caConfirm({
        title: DELETE_TITLE,
        message: DELETE_MESSAGE,
        confirmButtonText: 'Excluir registro',
        onConfirm: () => {
          deleteEvent(id)
            .then(() => {
              this.$delete(this.events.content, index);
              this.$toaster.success('Evento excluído com sucesso.');
            })
            .catch(() => {
              this.$toaster.error('Erro ao excluir evento');
            });
        },
      });
    },
  },
};
</script>
